import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, Grid, InputAdornment, Switch, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { globalGetService, globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { putLesseeDetailsApi, defaultBankDropdown, getConsantApi } from '../apiServices';
import { checkApiStatus, numberWithCommas, formatCycles, getTextFieldRows } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { regexConstants } from '../../../../constants/regEx';
import { trackActivity } from '../../../../utils/mixpanel';
import { useDispatch } from 'react-redux';
import { fetchLeaseBasicDetails } from '../../../../shared_elements/actionCreators';
import  InfoOutlineIcon  from '@mui/icons-material/InfoOutline';
import InfoIcon from '@mui/icons-material/Info';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';
import { gaTelesisInstance } from '../../../../shared_elements';


const LeaseInformationCRU = ({ editLeaseInfo, onToggleModal, params, getResponseBack, modeType }) => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false);
    const [leaseDetail, setLeaseDetail] = useState(editLeaseInfo.data || {});
    const [error, setError] = useState({});
    const [pltConstants, setPltConstants] = useState([]);
    const [dropDownloader, setDropDownLoader] = useState({ constant: false, bank: false })
    const [defaultBank, setDefaultBank] = useState([]);
    const leaseDurationTypeValue = typeof leaseDetail?.lease_duration_type === 'object' ? leaseDetail?.lease_duration_type?.value : leaseDetail?.lease_duration_type;
    const rollingleaseDurationType = [{ value: 1, label: 'Days' }, { value: 2, label: 'Months' }];
    const [cleared, setCleared] = useState(false);
   
    useEffect(() => {
        if(modeType!=='view'){
            getPltConstants();
            getBankDefault();
        }
            if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])
    const handelLeaseDetails = () => {
        let validationInputs = {};
        validationInputs = {
            lease_type: leaseDetail?.lease_type ? "" : "Please select Lease Type",
            contractual_start_date: leaseDetail?.contractual_start_date ? "" : `Please select ${ gaTelesisInstance ? "Lease Signature Date" : "Lease Contractual Start Date" }`,
            rolling_lease_span:leaseDetail?.rolling_lease_status ? leaseDetail?.rolling_lease_span? "":"Please select Duration Type":"",
            start_date: leaseDetail?.start_date ? "" : "Please select a valid Start Date",
            end_date: ![3, 5].includes(leaseDurationTypeValue) ? leaseDetail?.end_date ? "" : "Please select a valid End Date":"",
            planned_utilization_fh: leaseDurationTypeValue === 3 ? leaseDetail?.planned_utilization_fh ? "" : "Please enter Planned Utilization(FH)" : "",
            planned_utilization_fc: leaseDurationTypeValue === 5 ? leaseDetail?.planned_utilization_fc ? "" : "Please enter Planned Utilization(FC)" : "",

        }
        const startDate = moment(leaseDetail?.start_date);
        const endDate = moment(leaseDetail?.end_date);
        const contractStartDate=moment(leaseDetail?.contractual_start_date);
        const novationDate = moment(leaseDetail?.novation_date);
        if (leaseDetail?.start_date && leaseDetail?.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before start date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after end date";
            }
            if (leaseDetail?.start_date && !startDate.isValid()) {
                validationInputs.start_date = "Please enter valid start date";
            }
            if(leaseDetail?.contractual_start_date && contractStartDate.isAfter(startDate)) validationInputs['contractual_start_date']=`${ gaTelesisInstance ? "Lease Signature Date" : "Lease Contractual Start Date" } cannot be after start date`;
            if(leaseDetail?.contractual_start_date && !contractStartDate.isValid()) {
                validationInputs.contractual_start_date = `Please enter valid ${ gaTelesisInstance ? "Lease Signature Date" : "Lease Contractual Start Date" }`
            }
            if (leaseDetail?.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid end date";
            }
            if (leaseDetail?.novation_date && !novationDate.isValid()) {
                validationInputs.novation_date = "Please enter valid novation date"
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, leaseDetail);
            payload = {
                ...payload,
                lessee_id: leaseDetail?.lease_details,
                default_bank_id: leaseDetail?.default_bank,
                lease_duration_type: leaseDetail?.lease_duration_type?.value
            };
            if(leaseDetail?.lease_duration_type?.value!==1){
                delete payload.rolling_lease_status;
                delete payload.rolling_lease_duration;
                delete payload.rolling_lease_span;
                delete payload.rolling_lease_from;
            } 

            globalPutService(putLesseeDetailsApi(params,{'cross_feature_check': 'lease_details'}), payload)
                .then(async (response) => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        onToggleModal();
                        dispatch(fetchLeaseBasicDetails({ slug: params,setLoading}));
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Headlines Lease Information`, success_msg: response?.data?.message, item_slug:params, payload: payload, response: response?.data })
                    } else {
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                        trackActivity('Item Edited', { page_title: `Edit Headlines Lease Information`, error_msg: response?.data?.message, item_slug: params, payload: payload, response: response?.data })
                    }
                    setLoading(false);
                })
        }
        else {
            setError(validationInputs);
            trackActivity(`Item Edited`, { page_title: `Edit Headlines Lease Information`, error_msg: validationInputs, })
        }
    }

    const onRestErrorKey = (keyParam) => {
        if(keyParam==='start_date'){
            setError({ ...error, [keyParam]: '',contractual_start_date:'' })
        }
        else setError({ ...error, [keyParam]: '' })
    }
    const getPltConstants = () => {
         setDropDownLoader(prev => ({ ...prev, constant: true }));
        globalPostService(getConsantApi(), { 'constant_types': ['lease_type', 'lease_type_accounting','lease_duration_type'] })
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, constant: false }));
                if (checkApiStatus(response)) {
                    setPltConstants(response?.data?.data);
                }
            })
    }
    const getBankDefault = () => {
         setDropDownLoader(prev => ({ ...prev, bank: true }));
        globalGetService(defaultBankDropdown())
            .then(response => {
              setDropDownLoader(prev => ({ ...prev, bank: false }));
                if (checkApiStatus(response)) {
                    setDefaultBank(response?.data?.data);
                }
            })
    }
    const getDurationInMonthsDays = (startDate, endDate) => {
        if (!startDate || !endDate) return "";

        const start = moment(startDate);
        const end = moment(endDate);

        if (!start.isValid() || !end.isValid()) return "";

        const months = end.diff(start, "months");
        const days = end.diff(start.clone().add(months, "months"), "days");

        const monthText = months
            ? `${months} Month${months !== 1 ? "s" : ""}`
            : "";

        const dayText = days
            ? `${days} Day${days !== 1 ? "s" : ""}`
            : "";

        return [monthText, dayText].filter(Boolean).join(" ");
    };
    const handelInputChange = (key, value) => {
        if(key==='rolling_lease_span'){
            if(value===2) setLeaseDetail({ ...leaseDetail, [key]: value,'rolling_lease_duration':1 })
            else setLeaseDetail({ ...leaseDetail, [key]: value,'rolling_lease_duration':0 })
        }
        else if(key==='rolling_lease_status' && value){
            setLeaseDetail({ ...leaseDetail, [key]: value,'rolling_lease_span':2,'rolling_lease_duration':1 })
        }
        else{
            setLeaseDetail({
                ...leaseDetail,
                [key]: value,
            })
        }
        }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType==='view'? 'View':'Edit'} Lease Information`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dilog"
                maxWidth="md"
                fullWidth
                open={editLeaseInfo?.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header'>
                    <Typography className="dialog-header-title">{modeType==='edit'?'Edit':'View'} Lease Information </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                disabled={modeType === 'view'}
                                options={pltConstants?.filter(item => item?.type === 'lease_type')}
                                noOptionsText={dropDownloader?.constant ? "Loading..." :"No Option Available" }
                                getOptionLabel={(option) => option?.label || ""}
                                value={leaseDetail?.lease_type || null}
                                onChange={(event, newValue) => {
                                    handelInputChange("lease_type", newValue);
                                }}
                                onFocus={() => setError((prev) => ({ ...prev, lease_type: "" }))}
                                isOptionEqualToValue={(option, val) => option?.value === val?.value}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField {...params} label="Lease Type" variant="outlined" size="small" margin="normal" fullWidth required slotProps={{inputLabel: {shrink: true,},input:{ ...params?.InputProps,endAdornment: (<>{dropDownloader?.constant   ? ( <CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</> ) }}} helperText={error.lease_type} error={error.lease_type} placeholder='Select Lease Type' /></Tooltip>
                                    )}}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Autocomplete
                                disablePortal
                                disabled={modeType === 'view'}
                                options={pltConstants?.filter(item => item?.type === "lease_type_accounting")}
                                noOptionsText={dropDownloader?.constant ? "Loading..." :"No Option Available" }
                                getOptionLabel={(option) => option?.label || ""}
                                isOptionEqualToValue={(option, val) => option?.value === val?.value}
                                value={leaseDetail?.lease_type_accounting || null}
                                onChange={(event, newValue) => {
                                    handelInputChange("lease_type_accounting", newValue);

                                }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField {...params} label="Lease Type ( Accounting )" variant='outlined' size='small' margin='normal' fullWidth slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{dropDownloader?.constant ? (<CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</>) } }} helperText={error.lease_type_accounting} error={error.lease_type_accounting} placeholder='Select Lease Type (Accounting)' /></Tooltip>
                                    )
                                }}
                            />
                        </Grid>
                        {/* <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Autocomplete
                                disablePortal
                                disabled={modeType === 'view'}
                                options={defaultBank}
                                 noOptionsText={dropDownloader?.bank ? "Loading..." :"No Option Available" }
                                getOptionLabel={(option) => option?.account_name || option.name || ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                value={leaseDetail?.default_bank || null}
                                onChange={(event, newValue) => {
                                    handelInputChange("default_bank", newValue);
                                }}
                                renderInput={(params) =>{
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField sx={{ width: "100%" }} {...params} label="Default Bank" variant="outlined" size="small" margin="normal" fullWidth slotProps={{inputLabel: {shrink: true,},input:{ ...params?.InputProps,endAdornment: (<>{dropDownloader?.bank   ? ( <CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</> ) }}} placeholder='Select Bank' /></Tooltip>
                                    )
                                }}
                            />
                        </Grid> */}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={leaseDetail?.assigned_code?.length > 23 ? leaseDetail?.assigned_code : ""} placement="bottom" arrow>
                                <TextField
                                    label="Assigned Code"
                                    varient="outlined"
                                    value={leaseDetail?.assigned_code || ""}
                                    size="small"
                                    margin="normal"
                                    disabled={true}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Tooltip title={leaseDetail?.lease_number?.length > 23 ? leaseDetail?.lease_number : ""} placement="bottom" arrow>
                            <TextField
                                id='leaseNumber'
                                label="Lease/Contract Number"
                                value={leaseDetail?.lease_number ? leaseDetail?.lease_number : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("lease_number", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                disabled={modeType === 'view'}
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Tooltip title={leaseDetail?.rental_account_number?.length > 23 ? leaseDetail?.rental_account_number : ""} placement="bottom" arrow>
                            <TextField
                                id='rental_account_number'
                                label="Rental Account Number"
                                value={leaseDetail?.rental_account_number ? leaseDetail?.rental_account_number : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("rental_account_number", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled={modeType === 'view'}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Tooltip title={leaseDetail?.lease_duration_type?.label?.length > 23 ? leaseDetail?.lease_duration_type?.label : ""} placement="bottom" arrow>
                            <TextField
                                id='lease_duration_type'
                                label="Lease Duration Type"
                                value={leaseDetail?.lease_duration_type?.label ? leaseDetail?.lease_duration_type?.label : ""}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={true}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker value={leaseDetail?.contractual_start_date ? moment(leaseDetail?.contractual_start_date) : null} label={gaTelesisInstance ? "Lease Signature Date" : "Lease Contractual Start Date"}
                                 id='contractual_start_date'
                                    slotProps={{ 
                                        textField: { 
                                            required: "true", 
                                            InputLabelProps: { shrink: true },
                                            size: "small", 
                                            margin: "normal", 
                                            error: error.contractual_start_date || false, 
                                            helperText: error.contractual_start_date || '', 
                                            onFocus: () => {
												if (error.contractual_start_date) {
													onRestErrorKey("contractual_start_date");
												}
											}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("contractual_start_date", null);
                                                onRestErrorKey("contractual_start_date");
                                                setCleared(true);
                                            }
                                        }
                                    }}
                                    format={fieldDateFormat}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view' || leaseDetail?.rolling_lease_status}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        handelInputChange("contractual_start_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("contractual_start_date");
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker value={leaseDetail?.start_date ? moment(leaseDetail?.start_date) : null} label="Lease Start Date" id='start_date'
                                    slotProps={{ 
                                        textField: { 
                                            required: "true", 
                                            InputLabelProps: { shrink: true }, 
                                            size: "small", 
                                            margin: "normal", 
                                            error: error.start_date || false, 
                                            helperText: error.start_date || '',
                                            onFocus: () => {
												if (error.start_date) {
													onRestErrorKey("start_date");
												}
											}
                                         },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("start_date", null);
                                                onRestErrorKey("start_date");
                                                setCleared(true);
                                            }
                                        }
                                    }}
                                    format={fieldDateFormat}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view' || leaseDetail?.rolling_lease_status}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                                        handelInputChange("start_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("start_date");
                                            if (leaseDetail?.end_date && !moment(formattedDate).isAfter(moment(leaseDetail.end_date))) {
                                                setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {![3, 5].includes(leaseDurationTypeValue) && 
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker value={leaseDetail?.end_date ? moment(leaseDetail?.end_date) : null} label="Lease End Date" id='end_date'
                                    slotProps={{ 
                                        textField: { 
                                            required: "true", 
                                            InputLabelProps: { shrink: true }, 
                                            size: "small", 
                                            margin: "normal", 
                                            error: error.end_date || false, 
                                            helperText: error.end_date || '',
                                            onFocus: () => {
												if (error.end_date) {
													onRestErrorKey("end_date");
												}
											}
                                         },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("end_date", null);
                                                onRestErrorKey("end_date"); 
                                                setCleared(true);
                                            }
                                        }
                                    }}
                                    format={fieldDateFormat}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view' || leaseDetail?.rolling_lease_status}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                                        handelInputChange("end_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("end_date");
                                            if (leaseDetail?.start_date && !moment(formattedDate).isBefore(moment(leaseDetail?.start_date))) {
                                                setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                            }
                                        }
                                    }}
                                    minDate={leaseDetail?.start_date ? moment(leaseDetail?.start_date) : null}
                                />
                            </LocalizationProvider>
                        </Grid>}
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Tooltip title={leaseDetail?.mr_account_number?.length > 23 ? leaseDetail?.mr_account_number : ""} placement="bottom" arrow>
                            <TextField
                                id='mr_account_number'
                                label="MR Account Number"
                                value={leaseDetail?.mr_account_number ? leaseDetail?.mr_account_number : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("mr_account_number", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled={modeType === 'view'}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Tooltip title={leaseDetail?.onlyNumeric?.length > 23 ? leaseDetail?.onlyNumeric : ""} placement="bottom" arrow>
                            <TextField
                                id='lease_term_months'
                                label="Lease Term"
                                disabled={true}
                                value={ getDurationInMonthsDays(leaseDetail?.start_date, leaseDetail?.end_date) || ""}
                                onChange={(e) => regexConstants?.onlyNumeric.test(e.target.value) ? handelInputChange("lease_term_months", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={leaseDetail?.governing_law?.length > 23 ? leaseDetail?.governing_law : ""} placement="bottom" arrow>
                            <TextField
                                id='governing_law'
                                label="Governing Law"
                                value={leaseDetail?.governing_law ? leaseDetail?.governing_law : ""}
                                onChange={(e) => handelInputChange("governing_law", e.target.value)}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                disabled={modeType === 'view'}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='planned_utilization'
                                label={
                                    <span>
                                        Planned Utilization(FH)
                                        <Tooltip placement='right' title={<span>To calculate lease expected End Date </span>} arrow>
                                            <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                                        </Tooltip>
                                    </span>
                                }
                                required={leaseDurationTypeValue === 3}
                                value={modeType === 'view' ? (leaseDetail?.planned_utilization_fh ? numberWithCommas(leaseDetail?.planned_utilization_fh) : "") : (leaseDetail?.planned_utilization_fh ? leaseDetail?.planned_utilization_fh : "")}
                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handelInputChange("planned_utilization_fh", e.target.value.trimStart()) : e.preventDefault();}}
                                onFocus={()=> onRestErrorKey('planned_utilization_fh')}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 10} }}
                                disabled={modeType === 'view'}
                                error={Boolean(error?.planned_utilization_fh)}
                                helperText={error?.planned_utilization_fh}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='planned_utilization'
                                label={
                                    <span>
                                        Planned Utilization(FC)
                                        <Tooltip placement='right' title={<span>To calculate lease expected End Date </span>} arrow>
                                            <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                                        </Tooltip>
                                    </span>
                                }
                                required={leaseDurationTypeValue === 5}
                                value={modeType === 'view' ? (leaseDetail?.planned_utilization_fc ? formatCycles(leaseDetail?.planned_utilization_fc) : "") : (leaseDetail?.planned_utilization_fc ? leaseDetail?.planned_utilization_fc : "")}
                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handelInputChange("planned_utilization_fc", e.target.value) : e.preventDefault();}}
                                onFocus={()=> onRestErrorKey('planned_utilization_fc')}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 10} }}
                                disabled={modeType === 'view'}
                                error={Boolean(error?.planned_utilization_fc)}
                                helperText={error?.planned_utilization_fc}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Lease Novation Date"
                                    value={leaseDetail?.novation_date ? moment(leaseDetail?.novation_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        handelInputChange("novation_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("novation_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.novation_date || false, 
                                            helperText: error.novation_date || '',
                                            onFocus: () => {
												if (error.novation_date) {
													onRestErrorKey("novation_date");
												}
											}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("novation_date", null);
                                                onRestErrorKey("novation_date");
                                                setCleared(true);
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={leaseDetail?.head_leases?.length > 23 ? leaseDetail?.head_leases : ""} placement="bottom" arrow>
                            <TextField
                                id='headleases'
                                label="Headleases"
                                value={leaseDetail?.head_leases ? leaseDetail?.head_leases : ""}
                                onChange={(e) => handelInputChange("head_leases", e.target.value)}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                disabled={modeType === 'view'}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={leaseDetail?.choice_of_forum?.length > 23 ? leaseDetail?.choice_of_forum : ""} placement="bottom" arrow>
                            <TextField
                                id='choice_of_forum'
                                label="Choice Of Forum"
                                value={leaseDetail?.choice_of_forum ? leaseDetail?.choice_of_forum : ""}
                                onChange={(e) => handelInputChange("choice_of_forum", e.target.value)}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                disabled={modeType === 'view'}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={leaseDetail?.jurisdiction?.length > 23 ? leaseDetail?.jurisdiction : ""} placement="bottom" arrow>
                            <TextField
                                id='jurisdiction'
                                label="Jurisdiction"
                                value={leaseDetail?.jurisdiction ? leaseDetail?.jurisdiction : ""}
                                onChange={(e) => handelInputChange("jurisdiction", e.target.value)}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                disabled={modeType === 'view'}
                            />
                            </Tooltip>
                        </Grid>
                        {![1].includes(leaseDurationTypeValue) && (
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='time_between_overhaul'
                                label="Time between Overhaul"
                                value={modeType === 'view' ? (leaseDetail?.time_between_overhaul ? numberWithCommas(leaseDetail?.time_between_overhaul) : "") : (leaseDetail?.time_between_overhaul ? leaseDetail?.time_between_overhaul : "")}
                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handelInputChange("time_between_overhaul", e.target.value) : e.preventDefault()}}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 10} }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>)}
                        {![1].includes(leaseDurationTypeValue) && (
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='last_overhaul_tsn'
                                label="Last Overhaul TSN"
                                value={modeType === 'view' ? (leaseDetail?.last_overhaul_tsn ? numberWithCommas(leaseDetail?.last_overhaul_tsn) : "") : (leaseDetail?.last_overhaul_tsn ? leaseDetail?.last_overhaul_tsn : "")}
                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handelInputChange("last_overhaul_tsn", e.target.value) : e.preventDefault()}}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 10} }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>)}
                        {![1].includes(leaseDurationTypeValue) && (
                            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                <TextField
                                    id='lease_duration'
                                    label="Lease Duration"
                                    value={leaseDetail?.lease_duration ? leaseDetail?.lease_duration : ""}
                                    onChange={(e) => regexConstants?.numberWithDot.test(e.target.value) || e.target.value === "" ? handelInputChange("lease_duration", e.target.value) : e.preventDefault()}
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    fullWidth
                                    disabled={modeType === 'view'}
                                    slotProps={{
                                        inputLabel: { shrink: true },
                                        htmlInput: { maxLength: 10, inputMode: "decimal" },
                                        input: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {[2, 3].includes(leaseDurationTypeValue) ? "FH" : "FC"}
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            </Grid>)}
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Tooltip title={leaseDetail?.insurance_type?.length > 23 ? leaseDetail?.insurance_type : ""} placement="bottom" arrow>
                                <TextField
                                    id='insurance_type'
                                    label={
                                        <span>
                                            Insurance Type
                                            <Tooltip placement='right' title={<span>Contingent or Possessed</span>} arrow>
                                                <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                                            </Tooltip>
                                        </span>
                                    }
                                    value={leaseDetail?.insurance_type ? leaseDetail?.insurance_type : ""}
                                    onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("insurance_type", e.target.value) : e.preventDefault()}
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    fullWidth
                                    disabled={modeType === 'view'}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                />
                            </Tooltip>
                        </Grid>
                        {leaseDurationTypeValue === 1 && (<>
                            <Grid size={{ xs: 12, md: 12, sm: 6 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: "5px", cursor: modeType === "view" ? "not-allowed" : "pointer" }}>
                                    <span>{leaseDetail?.rolling_lease_status === true ? 'Enabled' : 'Disabled'}</span>
                                    <Switch disabled={modeType === "view" || moment().isAfter(moment(leaseDetail?.end_date), 'day')} checked={leaseDetail?.rolling_lease_status === true ? true : false} onChange={(e) => handelInputChange('rolling_lease_status', e.target.checked)} />
                                    <span>Rolling Lease</span>
                                    <Tooltip title={moment().isAfter(moment(leaseDetail?.end_date), 'day') ? 'Rolling Lease cannot be enabled after Lease End Date' : 'Click to enable Rolling Lease which will extend the lease as per selected Duration Type and will keep repeating until disabled.'}><InfoOutlineIcon fontSize='10px' color='primary' /></Tooltip>
                                </Box>
                            </Grid>
                            {leaseDurationTypeValue === 1 && leaseDetail?.rolling_lease_status && (<>
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <Autocomplete
                                        disablePortal
                                        disableClearable
                                        options={rollingleaseDurationType}
                                        getOptionLabel={(option) => option.label || ""}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        value={rollingleaseDurationType.find((item) => (item.value === leaseDetail?.rolling_lease_span)) || null}
                                        onChange={(e, value) => { handelInputChange('rolling_lease_span', value?.value) }}
                                        onFocus={()=> onRestErrorKey('rolling_lease_span')}
                                        disabled={modeType === "view"}
                                        renderInput={(params) => (
                                            <TextField
                                                required
                                                {...params}
                                                label="Duration Type"
                                                margin='normal'
                                                size='small'
                                                slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, } }}
                                                error={error?.rolling_lease_span}
                                                helperText={error?.rolling_lease_span}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                    <TextField
                                        id='rolling_lease_from'
                                        label="From"
                                        value={ leaseDetail?.end_date? moment(leaseDetail.end_date).add(1,"day").format(fieldDateFormat) : null}
                                        variant='outlined'
                                        size='small'
                                        margin='normal'
                                        fullWidth
                                        disabled
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                {leaseDurationTypeValue === 1 && leaseDetail?.rolling_lease_status && leaseDetail?.rolling_lease_span && (
                                    <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                                        <TextField
                                            id='rolling_lease_span'
                                            label={`No. of ${leaseDetail?.rolling_lease_span === 1 ? 'Days' : 'Months'}`}
                                            value={leaseDetail?.rolling_lease_duration || ""}
                                            onChange={(e) => handelInputChange("rolling_lease_duration", e.target.value)}
                                            variant='outlined'
                                            size='small'
                                            margin='normal'
                                            fullWidth
                                            disabled={modeType === 'view' || leaseDetail?.rolling_lease_span === 2}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                        />
                                    </Grid>)}
                            </>)}
                        </>)}
                        <Grid size={{ xs: 12, md: 12, sm: 6 }}>
                            <Tooltip title={leaseDetail?.definition_of_lease_period?.length > 23 ? leaseDetail?.definition_of_lease_period : ""} placement="bottom" arrow>
                            <TextField
                                id='definition_of_lease_period'
                                label="Lease Definition of Lease Period"
                                value={leaseDetail?.definition_of_lease_period ? leaseDetail?.definition_of_lease_period : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("definition_of_lease_period", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                multiline
                                rows={getTextFieldRows(leaseDetail?.definition_of_lease_period, 3, 100)}
                                disabled={modeType === 'view'}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12, sm: 6 }}>
                            <Tooltip title={leaseDetail?.conditions_precedent?.length > 23 ? leaseDetail?.conditions_precedent : ""} placement="bottom" arrow>
                            <TextField
                                id='conditions_precedent'
                                label="Conditions Precedent"
                                value={leaseDetail?.conditions_precedent ? leaseDetail?.conditions_precedent : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("conditions_precedent", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                multiline
                                rows={getTextFieldRows(leaseDetail?.conditions_precedent, 3, 100)}
                                disabled={modeType === 'view'}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12, sm: 6 }}>
                            <Tooltip title={leaseDetail?.alternate_dispute_redressal?.length > 23 ? leaseDetail?.alternate_dispute_redressal : ""} placement="bottom" arrow>
                            <TextField
                                id='alternate_dispute_redressal'
                                label="Alternate Dispute Redressal"
                                value={leaseDetail?.alternate_dispute_redressal ? leaseDetail?.alternate_dispute_redressal : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("alternate_dispute_redressal", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                multiline
                                rows={getTextFieldRows(leaseDetail?.alternate_dispute_redressal, 3, 100)}
                                disabled={modeType === 'view'}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                            />
                            </Tooltip>
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={leaseDetail?.remarks} />
                        </Grid> :
                            <Grid size={{ xs: 12, md: 12, sm: 6 }}>
                                <TextField
                                    id='remarks'
                                    label="Remarks"
                                    value={leaseDetail?.remarks ? leaseDetail?.remarks : ""}
                                    onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("remarks", e.target.value) : e.preventDefault()}
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    fullWidth
                                    multiline
                                    rows={3}
                                    disabled={modeType === 'view'}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                            </Grid>}
                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box className="check-item-div" sx={{cursor: modeType === "view" ? "not-allowed" : "pointer"}}>
                                    {/* <FormControlLabel id='Reserve Rate Not Applicable' control={ */}
                                    <Checkbox disableRipple checked={leaseDetail?.is_reserve_rate === 1} onChange={(e) => handelInputChange("is_reserve_rate", e.target.checked ? 1 : 0)} disabled={modeType === 'view'} />
                                    {/* // } ></FormControlLabel> */}
                                    <Typography className="check-item-span" fontSize='14px'>Reserve Rate Not Applicable</Typography>
                                </Box>
                            </FormGroup>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); handelLeaseDetails() }}> {isLoading ? <CircularProgress color='inherit' size={24} /> : "Save"} </Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default LeaseInformationCRU;